import React from "react";

import InstructureItemStatus from "./InstructureStatusItem";
import { useIsMobile } from "@shared/hooks/useIsMobile";

interface InstructorEducationProps {
  instructorStatistic: {
    name: string;
    icon: React.FC<any>;

    value: string | undefined;
    sort: number;
    enable: boolean;
  }[];
  years: number;
  showYears: boolean;
}

const InstructorEducation: React.FC<InstructorEducationProps> = ({
  years,
  showYears,
  instructorStatistic,
}) => {
  const isMobile = useIsMobile(1240);
  if (!instructorStatistic.length) return null;

  const currentList = (
    isMobile
      ? instructorStatistic.sort((a, b) => a.sort - b.sort)
      : instructorStatistic
  ).filter((value) => value && value.enable);
  return (
    <div className="fds-l:pt-0 pt-4     fds-l:mt-8   mt-4     fds-l:border-t-0 border-t border-t-fds-default ">
      <div className="px-4     fds-l:mb-6  mb-3  fds-l:py-1 flex-col gap-y-2  fds-l:flex-row flex fds-l:justify-between fds-l:items-center">
        {currentList.map(({ icon: Icon, value, name }, idx) => {
          return (
            <InstructureItemStatus
              key={idx}
              value={value}
              name={name}
              icon={Icon}
            />
          );
        })}
      </div>
    </div>
  );
};

export default InstructorEducation;
